import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=0c68d7b1&scoped=true&"
import script from "./confirm.vue?vue&type=script&lang=js&"
export * from "./confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c68d7b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xushanB/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c68d7b1')) {
      api.createRecord('0c68d7b1', component.options)
    } else {
      api.reload('0c68d7b1', component.options)
    }
    module.hot.accept("./confirm.vue?vue&type=template&id=0c68d7b1&scoped=true&", function () {
      api.rerender('0c68d7b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/applyManage/gdApply/confirm.vue"
export default component.exports